import { LDateTime } from '@app/components/date/LDateTime';
import { ListViewLocalChildProps } from '@app/core/list-view/ListViewLocal';
import { User } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { UserRoleInfo } from '../components/UserRoleInfo';

export type UsersListProps = ListViewLocalChildProps<User>;

/**
 * Admin users table for ListViewLocal. Filters live in the DataToolbar.
 */
export function UsersList({
  data,
  isLoading = false,
  isFetching = false,
  showProgress = true,
}: UsersListProps) {
  const { formatMessage } = useIntl();

  return (
    <Box>
      <MrtTable<User>
        data={data}
        navigateToOnClick={(id) => `/admin/users/${id}`}
        enableNavigateAction
        enableColumnFilters={false}
        enableGlobalFilter={false}
        enableToolbarInternalActions={false}
        defaultColumn={{
          enableSorting: true,
          enableColumnFilter: false,
          enableColumnActions: false,
        }}
        initialState={{
          sorting: [{ id: 'name', desc: false }],
        }}
        state={{
          isLoading,
          showProgressBars: showProgress && (isLoading || isFetching),
        }}
        muiTopToolbarProps={{
          sx: {
            height: '4px !important',
            minHeight: '4px !important',
          },
        }}
        columns={[
          {
            header: formatMessage({
              id: 'admin.users.name',
              defaultMessage: 'Nombre',
            }),
            id: 'name',
            accessorFn: (row) => {
              const fullName = [row.name, row.surname].filter(Boolean).join(' ');
              return fullName || '\u200B';
            },
            size: 160,
          },
          {
            header: formatMessage({
              id: 'common.email',
              defaultMessage: 'Email',
            }),
            id: 'email',
            accessorKey: 'email',
            size: 150,
          },
          {
            header: formatMessage({
              id: 'admin.users.role',
              defaultMessage: 'Rol',
            }),
            id: 'role',
            accessorKey: 'role',
            Cell: ({ row: { original } }) => <UserRoleInfo value={original.role} display="short" />,
            size: 80,
          },
          {
            header: formatMessage({
              id: 'admin.users.lastLogin',
              defaultMessage: 'Último login',
            }),
            id: 'lastLogin',
            accessorKey: 'lastLogin',
            accessorFn: (row) => (row.lastLogin ? new Date(row.lastLogin) : ''),
            Cell: ({ cell }) => (cell.getValue() ? <LDateTime value={cell.getValue()} /> : ''),
            size: 200,
          },
        ]}
      />
    </Box>
  );
}
